import {
  AlphaCollection,
  NumericCollection,
} from '../../components/Keyboard/types'

export type StationData = {
  address: string
  callsign: string
  common_name: string
  common_name_short: string
  confidence: number
  flagship: string
  membership_url: string
  pbs_id: string
  pdp: boolean
  rank: number
}

export type ChangeStationScreenResultProps = {
  children: React.ReactNode
  emptyCollectionResponse: boolean
  searchError: Error | null
  collectionsReady: boolean
  searchQuery: string
}

export type ChangeStationScreenHeaderProps = {
  children: (
    searchQuery: string,
    onEnterProps: (keyString: NumericCollection | AlphaCollection) => void
  ) => React.ReactNode
  handleSearchCleared: () => void
  onZipCodeEntered: (zipCode: string) => Promise<void> | void
  onDigitAdded?: (digit: string) => void
}

export type ChangeStationHeaderRef = {
  addDigit: (digit: string) => void
}

export enum SearchErrorEnum {
  NOT_FOUND,
  GENERIC,
}
